import { render } from "./parent-simplified.vue?vue&type=template&id=009cca46&scoped=true&ts=true"
import script from "./parent-simplified.vue?vue&type=script&lang=ts"
export * from "./parent-simplified.vue?vue&type=script&lang=ts"

import "./parent-simplified.vue?vue&type=style&index=0&id=009cca46&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009cca46"]])

export default __exports__